module.exports = __webpack_public_path__ + "static/moviebuff-acb3e14332465d1d26fdd117d829fd93.jpg";